module.exports = __webpack_public_path__ + "static/media/hero.62bcf31a.png";